import React, { Component, Dispatch } from 'react';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import Translator from '../../../../core/i18n';
import Moment from 'moment';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { Common } from '../../../../core/common';
import { IAppState, IAction } from '../../../../models/action/core';
import { connect } from 'react-redux';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import { enrollmentAddActionLog } from '../../../../store/actions/enrollment';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { UserType } from '../../../../models/pages/login.d';
import ProgressCircle from '../../../progress-circle/progress-circle';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import { Log } from 'ng2-logger';
import { FileOwnerType } from '../../../../models/enums/FileOwnerType';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { SetUpdateInput, getCourseContentsWeekActivitiesAction } from '../../../../store/actions/coursePage';
import EdiText from 'react-editext';
import Countdown from 'react-countdown';
import { CoursePageService } from '../../../../api/course-page-service';
import ReactGA from 'react-ga4';
import { Notification } from '../../../notification/main';
import PdfPreview from '../../../previews/pdf/main';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Assignment');
const coursePageService = new CoursePageService();
let nowDate = new Date();
let getActivityId: string;
const maxEditTextLength = 65;

interface IObj {
    hours: any;
    minutes: any;
    seconds: any;
    completed: any;
    days: any;
}
export class CAssignmentActivityCard extends Component<ISignleActivityCard, any> {
    state = {
        activityFiles: [{ fileName: '', filePath: '', size: '' }],
        userAssignmentFiles: [{ fileName: '', filePath: '', size: '' }],
        nowDate: Moment(this.props.activityCard!.serverDate).add(-1, 'minute').format('yyyy-MM-DDTHH:mm:ss'),
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString(),
        isModalOpen: false,
        selectedFile: { name: "", path: "" }
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        getActivityId = this.props.activityCard!.activityId!;
        this.afterSave = this.afterSave.bind(this);
    }

    public clickToDownload = (e: any) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_DOWNLOAD_ASSIGNMENT_FILE_CLICKED',
            label: 'G_DOWNLOAD_ASSIGNMENT_FILE_CLICKED',
            nonInteraction: true,
        });
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    }

    public clickToView = async (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();

        if (filepath && fileName) {
            this.setState({ selectedFile: { name: fileName, path: filepath }, isModalOpen: true })
        } else {
            Notification.setNotification('error', T.t('r_fileUpload_error'), 'topRight');
        }
    };

    setClosePrivewModal = () => {
        this.setState({ selectedFilePath: {}, isModalOpen: false })
    }

    public enrollmentAddAction = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_POST_ASSIGNMENT_CLICKED',
            label: 'G_POST_ASSIGNMENT_CLICKED',
            nonInteraction: true,
        });
        this.props.dispatch(
            enrollmentAddActionLog({
                ActivityCompletionType: ActivityCompletionType.View,
                ActivityId: this.props.activityCard!.activityId!,
                EnrollmentId: '',
                ClassId: this.props.classId
            })
        );

        this.props.sendAssignmentModalOpen(this.props.activityCard);
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.activityCard!.file !== prevProps.activityCard.file) {
            this.separateFiles();
        }
    }

    componentDidMount() {
        this.separateFiles();
    }

    separateFiles = () => {
        const { file } = this.props.activityCard || {};
        const activityFiles = file?.filter(file => file.ownerType !== FileOwnerType.User) || [];
        const userAssignmentFiles = file?.filter(file => file.ownerType === FileOwnerType.User) || [];      
        this.setState({ activityFiles, userAssignmentFiles });
    };

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId === '0' || false,
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined,this.props.sortKey ?? "-"));
    }

    userTypeCheck = () => {
        if (this.props.userType === UserType.Student) {
            return true
        }

        return false;
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });

        }
    }

    viewUploadSection = (isCompletedPrerequisiteActivity: any) => {

        const { activityCard, userType } = this.props;
        const { activityFiles } = this.state;

        if (!isCompletedPrerequisiteActivity && activityCard?.prerequisiteActivityId && userType === UserType.Student) {
            return '';
        }

        if (activityFiles?.length > 0 && activityFiles[0]?.filePath) {
            return (
                <div>
                    <hr className="bottom-border-2 mobile-line mx-0" />
                    <div className="row file-upload-section" style={{ marginLeft: 0, marginRight: 0 }}>
                        <span className="upload-title" tabIndex={0}>{T.t('r_activity_attachments2')}</span>
                        {activityFiles.map((file: any, fileIndex: number) => (
                            <div className="upload-file-temp" key={file?.fileName}>
                                {this.textShort(file)}
                                <div className="upload-desc d-flex justify-content-end gap-1">
                                    <button
                                        className="category-tag-square tag-gray mx-1"
                                        onClick={this.clickToDownload}
                                        data-filename={file?.fileName}
                                        data-filepath={file?.filePath}
                                        tabIndex={0}
                                    >
                                        <i className="material-icons mr-2">cloud_download</i>
                                        {T.t('r_download')}
                                    </button>
                                    {file.contentType == "application/pdf" &&
                                        <button
                                            className="category-tag-square tag-gray mx-1"
                                            onClick={this.clickToView}
                                            data-filename={file?.fileName}
                                            data-filepath={file?.filePath}
                                        >
                                            <i className="material-icons mr-2">visibility</i>
                                            {T.t('r_preview')}
                                        </button>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return '';
    }


    completedPrerequisiteActivityStatus = () => {

        let returnValue: any;
        let resultValue: boolean = false;

        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {


            if (this.props.enrollmentData) {
                if (this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId).length > 0) {
                    returnValue = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)[0].status;
                }
                else {
                    returnValue = 0;
                }
            }
            else {
                returnValue = 0;
            }

            if (returnValue === 2 && this.props.userType === 8) {
                resultValue = true;
            }

        }
        else {
            resultValue = true;
        }

        return resultValue;

    }

    viewActiveClassName = () => {

        let className = 'card new-activity';

        if (this.props.activityCard!.activeStatus === 0) {
            className = 'card new-activity border-pasif';
        }

        return className;
    }

    handleClickValue = () => {
        let returnValue = '';

        if (this.state.editTextValue.length > maxEditTextLength) {
            returnValue = this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...';
        }
        else {
            returnValue = this.state.editTextValue.toString();
        }

        return returnValue;

    }

    viewMaxUploadCount = () => {

        let count = 0;

        let returnValue = "0";

        if (this.props.activityCard) {
            if (this.props.activityCard.enrollmentAssignmentUploadedCount) {
                count = this.props.activityCard?.enrollmentAssignmentUploadedCount;
            }
            returnValue = count + "/" + this.props.activityCard.assignmentMaximumUploadCount;
        }

        return returnValue;

    }

    viewActivityBeginDate = () => {

        let returnValue = '-';

        if (this.props.activityCard!.customProperty5) {

            returnValue = Moment(this.props.activityCard!.customProperty5).format(
                _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3));
        }

        return returnValue;

    }

    viewActivityDeadlineDate = () => {

        let returnValue = '-';

        if (this.props.activityCard!.taskDeadLine) {

            returnValue = Moment(this.props.activityCard!.taskDeadLine).format(
                _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3));
        }

        return returnValue;


    }

    viewCountdown = (param: any) => {
        const { activityCard } = this.props;
        const { nowDate } = this.state;

        if (!activityCard?.taskDeadLine) return '';

        const nowTime = new Date(nowDate).getTime();
        const taskDeadlineTime = new Date(activityCard.taskDeadLine).getTime();

        if (nowTime >= taskDeadlineTime) return '';

        const renderCountdown = (title: string, countdownDate: number) => (
            <div className="row mx-0 d-flex align-items-center justify-content-between">
                <div className="col-md-3 col-12">
                    <span className="countdown-title d-flex">{title}</span>
                </div>
                <Countdown
                    onComplete={param.countdownIsComplete}
                    now={() => nowTime}
                    date={countdownDate}
                    renderer={param.renderer}
                />
            </div>
        );

        if (activityCard.customProperty5) {
            const customPropertyTime = new Date(activityCard.customProperty5).getTime();
            if (nowTime >= customPropertyTime) {
                return renderCountdown(T.t('r_add_assignment_left_end_date'), taskDeadlineTime);
            } else {
                return renderCountdown(T.t('r_add_assignment_left_begin_date'), customPropertyTime);
            }
        }

        return '';
    };


    checkActivityDeadline = () => {
        const { activityCard } = this.props;
        const { nowDate } = this.state;

        if (!activityCard?.taskDeadLine) return false;

        const taskDeadlineDate = new Date(activityCard.taskDeadLine);

        if (new Date(nowDate).getTime() < taskDeadlineDate.getTime()) {
            return true;
        }
        return false;
    };

    checkActivityStartDate = () => {
    
        const { activityCard } = this.props;
        const { nowDate } = this.state;

        if (!activityCard?.customProperty5) return false;

        const taskStartDate = new Date(activityCard.customProperty5);

        if (new Date(nowDate).getTime() < taskStartDate.getTime()) {
            return true;
        }

        return false;
    }


    viewSendAssignmentButton = (isCompletedPrerequisiteActivity: any) => {

        if (!this.userTypeCheck()) return '';

        if (!this.completedPrerequisiteActivityStatus()) return '';

        if (this.checkActivityStartDate()) return '';

        const sendAssignmentButton = (
            <div>
                <hr className="bottom-border-2" />
                <div className="card-footer">
                    <div style={{justifyContent: "end", display: "flex"}}>
                        <button
                            onClick={this.enrollmentAddAction}
                            className="success-btn"
                            disabled={!this.checkActivityDeadline()}
                        >
                            {T.t('r_send_assignment')}
                        </button>
                    </div>
                </div>
            </div>
        );

        return sendAssignmentButton;
    };


    viewEnrollmentScore = () => {
        const { userType, activityCard } = this.props;
        const enrollmentScore = (activityCard?.enrollmentScore === -1 || activityCard?.enrollmentScore == null) ? "---" : activityCard?.enrollmentScore;
        if (userType === UserType.Student) {
            return (
                <div className="activity-spec">
                    <div className="spec-icon note-green">
                        <img src={_common.GetDefaultIcons('aplus')} alt="" />
                    </div>
                    <div className="spec-text">
                        <span className="spec-title" tabIndex={0}>{T.t('r_assignment_grade')}</span>
                        <span className="spec-title-bold" tabIndex={0}>{enrollmentScore}</span>
                    </div>
                </div>
            );
        } else {
            const { evaluatedStudentCount, uploadedStudentCount } = activityCard || {};

            return (
                <div className="activity-spec">
                    <div className="spec-icon note-green">
                        <img src={_common.GetDefaultIcons('aplus')} alt="" />
                    </div>
                    <div className="spec-text">
                        <span className="spec-title mobile-none" tabIndex={0}>{T.t('r_assignment_graded_uploaded')}</span>
                        <span className="spec-title web-none mobile-display" tabIndex={0}>{T.t('r_assignment_graded')}</span>
                        <span className="spec-title web-none mobile-display" tabIndex={0}>{T.t('r_assignment_uploaded')}</span>
                        <span className="spec-title-bold" tabIndex={0}>{evaluatedStudentCount ?? "-"} / {uploadedStudentCount ?? "-"}</span>
                    </div>
                </div>
            );
        }
    }


    viewFiles = (isCompletedPrerequisiteActivity: any) => {



        if ((!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student)) {
            return '';
        }
        else if (this.state.userAssignmentFiles.length > 0 && this.state.userAssignmentFiles[0].filePath) {
            return (<div><hr className="bottom-border-2 mobile-line mx-0" />
                <div className="row file-upload-section" style={{ marginLeft: 0, marginRight: 0 }}>
                    <span className="upload-title">{T.t('r_gen_upload_assignment_file')}</span>
                    {this.state.userAssignmentFiles.map((file: any, fileIndex: any) =>
                        <div className="upload-file-confirm" key={file?.fileName}>
                            <div style={{ cursor: 'pointer' }} data-filename={file?.fileName} data-filepath={file?.filePath} onMouseDown={this.clickToDownload} className="upload-file-name mobile-activity-upload">
                                <img src={_common.GetDefaultIcons('blueattach')} className="ml-1 mr-3" alt="" />
                                <span>{file.fileName}</span>
                            </div>
                            <div className="upload-desc">
                                <button
                                    className="category-tag-square tag-gray mx-3"
                                    onClick={this.clickToDownload}
                                    data-filename={file?.fileName}
                                    data-filepath={file?.filePath}
                                >
                                    <i className="material-icons mr-2">cloud_download</i>
                                    {T.t('r_download')}
                                </button>
                                {/* <span>{_common.BytesToSize(file ? parseInt(file.size, 10) : 0)}</span> */}
                            </div>
                        </div>
                    )}
                </div></div>)
        }
        else {
            return '';
        }


    }




    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    textShort(file: any) {
        return (
            <button
                title={file.fileName}
                className="upload-file-name mobile-files web-files btn-style"
                style={{ cursor: 'pointer', overflow: 'hidden', whiteSpace: 'pre-line', textOverflow: 'ellipsis',width:'100%' }}
                data-filename={file?.fileName} data-filepath={file?.filePath}
                onMouseDown={this.clickToDownload} >
                <img src={_common.GetDefaultIcons('blueattach')} className="mx-3" alt="" />
                <span>{file.fileName}</span>
            </button>)

    };

    public renderer = (params: IObj) => {
        return (
            <>
                <div className="col-md-3 col-4">
                    <div className="countdown-timer"> {params.days <= 9 ? '0' + params.days : params.days} <span>{T.t('r_time_day')}</span>
                    </div>
                </div>
                <div className="col-md-3 col-4">
                    <div className="countdown-timer"> {params.hours <= 9 ? '0' + params.hours : params.hours} <span>{T.t('r_time')}</span>
                    </div>
                </div>
                <div className="col-md-3 col-4">
                    <div className="countdown-timer"> {params.minutes < 9 ? '0' + (params.minutes) : (params.minutes)}<span>{T.t('r_time_minute')}</span>
                    </div>
                </div>
            </>


        );
    };
    public countdownIsComplete = () => {
        this.setState({ nowDate: Moment(this.props.activityCard!.serverDate).add(5, 'second').format('yyyy-MM-DDTHH:mm:ss') });
    }

    public render() {
        let isCompletedPrerequisiteActivity: boolean = false;

        isCompletedPrerequisiteActivity = this.completedPrerequisiteActivityStatus();

        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return this.props.activityCard ? (
            <div className="col-12 mobile-padding card-width">
                <div className={this.viewActiveClassName()}>
                    <div className="card-header">
                        <div className={"activity-title "+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                            <img
                                src={_common.GetActivityTypeIcons('homework')}
                                alt="Homework Activity Icon"
                            />
                            {
                                Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                                    <div title={this.props.activityCard!.name} className="visible">
                                        <EdiText
                                            type="text"
                                            onSave={this.handleSave}
                                            onCancel={event => this.handleClick(this.handleClickValue())}
                                            onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                            value={this.state.editTextValue}
                                            showButtonsOnHover={true}
                                            saveButtonClassName="hideEditextSaveButton"
                                            cancelButtonClassName="hideEditextCancelButton"
                                            validationMessage={T.t('r_forum_tree_character')}
                                            // tslint:disable-next-line:jsx-no-lambda
                                            validation={val => val.trim().length >= 3}
                                            editOnViewClick={true}
                                            submitOnEnter={true}
                                            cancelOnEscape={true}
                                            className={'font-weight-bold mobile-activity-title web-activity-title'+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                            tabIndex={0}
                                        />
                                    </div>
                                ) : <div title={this.props.activityCard!.name} className={"visible mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} tabIndex={0} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{this.props.activityCard!.name}</div>
                            }

                            <ProcessingActivity
                                externalCssClassName="ml-auto show_on_mobile"
                                activityId={this.props.activityCard.activityId}
                                activityType={this.props.activityCard.activityType}
                            />

                        </div>
                        <div className="activity-status">
                        {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                        <span className="badges badges-homework activity-type">{T.t('r_activity_type_Assignment')}</span>
                            {/* <h6 style={{ margin: 'auto' }}>{this.viewAlertIcon()}</h6> */}

                            {this.props.userType === UserType.Student ? (
                                <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} activityCard={this.props.activityCard} />
                            ) : (
                                <ProgressCircle activityCard={this.props.activityCard} percent={this.props.activityCard!.completedUser === 0 ? 0 : ((this.props.activityCard!.completedUser! * 100) / this.props.activityCard!.totalEnrollUser!)} />
                            )}
                            &nbsp;
                            <ProcessingActivity
                                externalCssClassName="hide_on_mobile"
                                activityId={this.props.activityCard!.activityId}
                                activityType={this.props.activityCard!.activityType}
                            />
                        </div>
                    </div>
                    <hr className="bottom-border-2 mobile-line " />
                    <div className="card-body">
                        <div className="row mx-0 d-flex justify-content-between ">
                            <div className="activity-spec">
                                <div className="spec-icon exam-time"><img src={_common.GetDefaultIcons('homework')} alt="" /></div>
                                <div className="spec-text">
                                    <span className="spec-title" tabIndex={0}>{T.t('r_activity_assignment_upload_count')}</span>
                                    <span className="spec-title-bold" tabIndex={0}>{this.viewMaxUploadCount()}</span>
                                </div>
                            </div>

                            {this.viewEnrollmentScore()}

                            <div className="activity-spec">
                                <div className="spec-icon start-date"><img src={_common.GetDefaultIcons('houryellow')} alt="" /></div>
                                <div className="spec-text">
                                    <span className="spec-title" tabIndex={0}>{T.t('r_activity_begin_date')}</span>
                                    <span className="spec-title-bold" tabIndex={0}>{this.viewActivityBeginDate()}</span>
                                </div>
                            </div>
                            <div className="activity-spec">
                                <div className="spec-icon end-date"><img src={_common.GetDefaultIcons('hourred')} alt="" /></div>
                                <div className="spec-text">
                                    <span className="spec-title" tabIndex={0}>{T.t('r_activity_due_date')}</span>
                                    <span className="spec-title-bold" tabIndex={0}>{this.viewActivityDeadlineDate()}</span>
                                </div>
                            </div>
                        </div>
                        {!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student &&
                            <>
                                <hr className="bottom-border-2 mx-0" />

                                <div className='row' style={{
                                    opacity: 0.5, flexDirection: 'column',
                                    fontSize: '1em !important',

                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                }}>
                                    <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                                    <h5 className="font-medium">
                                        {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard!.name).replace('{1}', this.props.activityCard!.prerequisiteActivityName)}
                                    </h5>
                                </div></>}
                        {(this.checkActivityDeadline() || this.props.userType === UserType.Student) && <hr style={{ padding: 0, marginLeft: 0, marginRight: 0 }} className="bottom-border-2 mb-2" />}

                        {(!this.checkActivityDeadline() && this.props.userType === UserType.Student) &&
                            <div className="row d-flex justify-content-center align-items-center">
                                <span className='exam-text mt-2'>
                                    <b>{T.t('r_assignment_expired')}</b>
                                </span>
                            </div>}
                        {this.viewCountdown(this)}
                        {this.viewUploadSection(isCompletedPrerequisiteActivity)}
                        {(this.props.activityCard!.description && _common.removeHtmlTags(this.props.activityCard!.description).length>0) && <><hr style={{ padding: 0, marginLeft: 0, marginRight: 0 }} className="bottom-border-2 mobile-not-show" />
                            <div className="row mobile-not-show" >
                                <div className="col d-flex justify-content-start align-items-baseline new-activity-block" >
                                    <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                                    <p className="card-info-text card-info-text-width mobile-activity-description">
                                        <b>{T.t('r_add_exam_teacher_note')}</b> <span id='instructor_note' className={(!_common.isArabic(this.props.activityCard!.description, document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.activityCard!.description }} />
                                    </p>
                                </div>
                            </div></>}
                        {this.viewFiles(isCompletedPrerequisiteActivity)}
                    </div>
                    {this.viewSendAssignmentButton(isCompletedPrerequisiteActivity)}
                </div>
                <PdfPreview
                    modalIsOpen={this.state.isModalOpen}
                    selectedFile={this.state.selectedFile}
                    setCloseModal={this.setClosePrivewModal}
                />

            </div>
        ) : (
            <h4>{T.t('r_activity_was_not_found')}.</h4>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }
    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        userPreferences: state.profile.userPreferences.preferences,
        coursePageClassId: state.coursePage.coursePageClassId,
        enrollmentData: state.enrollment.enrollmentData,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities

    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const AssignmentActivityCard = connect(
    mapStateToProps,
    dispatchProps, null, { areStatesEqual }
)(CAssignmentActivityCard);

export default AssignmentActivityCard;
